import React, {useState, useEffect, useContext} from 'react';
import {UserContext} from '../common/UserContext';
import {ContentContext} from '../common/ContentContext';
import CircularLoader from "../common/CircularLoader";
import EditLoader from "../common/EditLoader";
import SaveLoader from "../common/SaveLoader";

const TitleHeaderRight = props => {
    const {user, userLoading, setUser} = useContext(UserContext);
    const {content, contentLoading, contentSaving, contentEditing} = useContext(ContentContext);

    return (
        <div className={'ch-page-header-right'}>
            <EditLoader visible={!contentSaving && contentEditing} lightStyle={true}/>
            <SaveLoader visible={contentSaving} lightStyle={true}/>
            <CircularLoader visible={userLoading || contentLoading} pageCentered={false} lightStyle={true}/>
            <div className={'ch-page-header-content'}>
                {user.adminUser && user.actForSchoolName != undefined &&
                    <div className={'ch-syllabus-title'}>
                        <span>{user.actForSchoolName}</span>
                    </div>
                }
                {user.adminUser && user.actForSchoolName == undefined && user.schoolName != undefined &&
                    <div className={'ch-syllabus-title'}>
                        <span>{user.schoolName}</span>
                    </div>
                }
                <div className={'ch-syllabus-title'}>
                    {content != undefined && content.currentSyllabus != undefined &&
                        <span>{content.currentSyllabus.syllabusName}</span>
                    }
                    {(content == undefined || content.currentSyllabus == undefined) && user.syllabusName != undefined &&
                        <span>{user.syllabusName}</span>
                    }
                </div>
            </div>
        </div>
    )
}

export default TitleHeaderRight;